import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class Occupation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getOccupationPV`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="occupation">
        <Col componentClass={ControlLabel} sm={5}>
          Occupation *
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <select
              className="custom-select"
              name="occupation"
              onChange={this.props.handleChangeOccupation}
              required
              value={this.props.occupation}
            >
              <option value="">Please select</option>
              {this.state.option.map((obj, index) => {
                const counter = index;
                return (
                  <option
                    value={obj.code}
                    key={counter}
                  >{obj.name}</option>
                );
              })}
            </select> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

Occupation.propTypes = {
  handleChangeOccupation: PropTypes.func,
  occupation: PropTypes.string
};

export default Occupation;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/occupation/Occupation.js